import { render } from "./Stair.vue?vue&type=template&id=2449437e&scoped=true"
import script from "./Stair.vue?vue&type=script&lang=js"
export * from "./Stair.vue?vue&type=script&lang=js"

import "./Stair.vue?vue&type=style&index=0&id=2449437e&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2449437e"]])

export default __exports__